(() => {
    let rellax;
  
    const reducedMotion = () =>
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
    const initRellax = () => {
      if (rellax) { rellax.destroy(); rellax = null; }
      if (reducedMotion()) return;
      if (!window.Rellax || !document.querySelector('.rellax')) return;
  
      // Make lg start at 992px, matching your WP behavior
      rellax = new Rellax('.rellax', {
        breakpoints: [576, 768, 992]
      });
    };
  
    document.addEventListener('DOMContentLoaded', initRellax);
    document.addEventListener('shopify:section:load', initRellax);
    document.addEventListener('shopify:section:reorder', initRellax);
    document.addEventListener('shopify:block:select', initRellax);
    document.addEventListener('shopify:section:unload', () => {
      if (rellax) { rellax.destroy(); rellax = null; }
    });
  })();